import {createRouter, createWebHistory} from 'vue-router'
import ElTemplate from '../App.vue'

const routes = [
    {
        path: '/',
        component: ElTemplate,
        meta: {locale: 'el'},
    },
    {
        path: '/en',
        component: ElTemplate,
        meta: {locale: 'en'},
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/'
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
